import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProfileService } from 'src/app/core/services/profile.service';

@Component({
  selector: 'app-business-field-modal',
  templateUrl: './business-field-modal.component.html',
  styleUrls: ['./business-field-modal.component.scss']
})
export class BusinessFieldModalComponent implements OnInit {
  @Input() businessData: any;

  allfield = true;
  isGSTSubmitted: boolean = false;
  isSubmitted: boolean = false;
  onboardBusinessProfileForm: FormGroup;
  businessType: any;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private _profileService: ProfileService
  ) { }

  ngOnInit() {

    this.onboardBusinessProfileForm = this.formBuilder.group({
      verification_proof_no: ["", Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.GST_PATTERN), Validators.minLength(15), Validators.maxLength(15), this.noWhitespaceValidator])],
      aadhar_number: ["", Validators.compose([Validators.pattern(REGEX_PATTERNS.AADHAR_PATTERN), Validators.minLength(12), Validators.maxLength(12)])],
      pan_number: ["", Validators.compose([Validators.pattern(REGEX_PATTERNS.GST_PATTERN), Validators.minLength(10), Validators.maxLength(10)])],
      business_id: ["", [Validators.required]],
      business_address: ["", [Validators.required]]
    });
    this.loadBusinessType();

  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = ((control.value ? control.value.toString() : control.value) || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  loadBusinessType() {
    this._profileService.loadBusinessType().subscribe(
      (response: any) => {
        if (response.success) {
          this.businessType = response.data.business;
        }
        else {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      }, (error: any) => {

      });
  }

  goToStep2(isSkipped) {
    if (!isSkipped) {
      this.isGSTSubmitted = true;
      if (this.onboardBusinessProfileForm.controls.verification_proof_no.invalid) {
        return;
      }
    }
    this.toggleContent();
  }

  closeDialog(status) {
    if (status) {
      this.businessData = {
        ...this.businessData,
        user_business: {
          ...this.businessData.user_business,
          ...this.onboardBusinessProfileForm.value
        }
      }
      this.businessData.user_business.business_address = this.businessData.user_business.business_address.trim();
      this.businessData = this.businessData
      this.activeModal.close({
        data: this.businessData
      });
    }
    else {
      this.activeModal.close();
    }
  }

  toggleContent() {
    this.allfield = !this.allfield;
  }

  goToStep3() {
    this.isSubmitted = true;

    if (this.onboardBusinessProfileForm.controls.business_id.invalid || this.onboardBusinessProfileForm.controls.business_address.invalid) {
      return;
    }
    this.closeDialog(true);

  }

}
